module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Robin-Hood.4f81541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Robin-Hood.jpg
// module id = +qxU
// module chunks = 0